import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_f4kavkbe9g: FaireBrandEntity = {
  token: "b_f4kavkbe9g",
  type: "brand",
  name: "HIDDENBRAND",
  avatarUrl:
    "https://cdn.faire.com/fastly/e69904a7ab0288c1e2f2649335bae3dab07a9f88560564b71dcdbba97cd48f25.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/720d6971a53796850455d42882c7271ceec1602a6199e9ef4606f1295aa42ebe.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e69904a7ab0288c1e2f2649335bae3dab07a9f88560564b71dcdbba97cd48f25.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/720d6971a53796850455d42882c7271ceec1602a6199e9ef4606f1295aa42ebe.jpeg",
  location: "CA, USA",
  minimumOrderDollars: 150,
  rating: 4,
  reviewCount: 522,
  isInsider: true,
  description:
    'California based "Hidden Brand" has mastered the modern chic style with a focus on empowering women by accentuating her lines that give sophisticated, sexy confidence while wearing our signature pieces.Our default lead time is 14-21days and if urgent lead time is requested, just message us and our customer service team will try their best to work specially for you.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:50.658Z",
    importedBy: "entity-db-cli",
  },
};
